export const categories = [
  {
    id: 'programming',
    name: '编程开发',
    slug: 'programming',
    description: '涵盖前端、后端、移动端等各类编程语言与框架的技术讨论',
    icon: 'ri-code-s-slash-line',
    articleCount: 128,
  },
  {
    id: 'security',
    name: '网络安全',
    slug: 'security',
    description: '网络安全攻防技术、漏洞分析、渗透测试与安全防护方案交流',
    icon: 'ri-shield-keyhole-line',
    articleCount: 96,
  },
  {
    id: 'ai',
    name: '人工智能',
    slug: 'ai',
    description: '机器学习、深度学习、自然语言处理与AI应用实践探讨',
    icon: 'ri-robot-line',
    articleCount: 87,
  },
  {
    id: 'devops',
    name: '运维架构',
    slug: 'devops',
    description: '云原生架构、容器化部署、CI/CD 流水线与高可用方案分享',
    icon: 'ri-server-line',
    articleCount: 74,
  },
  {
    id: 'database',
    name: '数据库技术',
    slug: 'database',
    description: '关系型与非关系型数据库的设计优化、性能调优与实战经验',
    icon: 'ri-database-2-line',
    articleCount: 63,
  },
  {
    id: 'mobile',
    name: '移动开发',
    slug: 'mobile',
    description: 'iOS、Android、跨平台移动应用开发技术与最佳实践',
    icon: 'ri-smartphone-line',
    articleCount: 55,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((cat) => cat.slug === slug) || null;
};